<template>
<div>
    <Breadcrumbs main="Admin" submain="About" title="About" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>About (UPTO 40 WORDS)</label>
                                        <b-form-textarea rows="4" class="form-control" type="text" v-model="about.about" placeholder="Enter short description" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Mission</label>
                                        <b-form-textarea rows="4" class="form-control" type="text" v-model="about.mission" placeholder="Enter mission" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Vision</label>
                                        <b-form-textarea rows="4" class="form-control" type="text" v-model="about.values" placeholder="Enter vision" />
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3"> 
                                <b-button @click="handleSubmit">Submit</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            about : {
                about: '',
                mission: '',
                values: ''
            }
        };
    },

    computed: {
        ...mapState({
            new_about: state => state.about.about,
            loading: state => state.about.aboutLoading,
            error: state => state.about.aboutError
        })
    },

    watch: {
        new_about(oldValue, newValue) {
            this.about = this.new_about
        }
    },

    mounted() {
        this.$store.dispatch("about/fetchAbout").then(() => {
            this.about = this.new_about
        })
    },

    methods: {
        resetModal() {
            this.about.about = null
            this.about.mission = null
            this.about.values = null
        },

        handleSubmit() {
            this.$store.dispatch("about/addAbout", {
                about: this.about
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        }
    }
};
</script>
